import { ADD_GROUP, UPDATE_GROUP, DELETE_GROUP, SEARCH_GROUP_TABLE, GO_TO_PAGE_GROUP_TABLE, SET_PAGE_SIZE_GROUP_TABLE, SORT_GROUP_TABLE, IUpdateableGroupData, ADD_WORKFLOW_TO_GROUP, UPDATE_GROUP_CUSTOM_FIELD_DATA, SET_MEMBERS_FOR_GROUP_REQUEST, SET_MEMBERS_FOR_GROUP, UPDATE_GROUP_REQUEST, ADD_MEMBER_TO_GROUP, REMOVE_MEMBER_FROM_GROUP, FilterGroupTableAction, FILTER_GROUP_TABLE, AddGroupAction, UpdateGroupRequestAction, UpdateGroupAction, AddMemberToGroupAction, RemoveMemberFromGroupAction, AddWorkflowToGroupAction, UpdateGroupCustomFieldDataAction, SetMembersForGroupRequestAction, SetMembersForGroupAction, DeleteGroupAction, SearchGroupTableAction, GoToPageGroupTableAction, SetPageSizeGroupTableAction, SortGroupTableAction, UnArchiveGroupAction, UN_ARCHIVE_GROUP, RemoveWorkflowFromGroupAction, REMOVE_WORKFLOW_FROM_GROUP, BulkRemoveMembersFromGroupsAction, BulkAddMembersToGroupsAction, BULK_ADD_MEMBERS_TO_GROUPS, BULK_REMOVE_MEMBERS_FROM_GROUPS, GroupMemberLink, SetIsFilteringForGroupTableAction, SET_IS_FILTERING_FOR_GROUP_TABLE, SetIsShowingAddFormForGroupsAction, SetIsShowingCSVFormForGroupsAction, SetIsShowingFilterFormForGroupsAction, SetIsShowingModifyFormForGroupsAction, SET_IS_SHOWING_ADD_FORM_FOR_GROUPS, SET_IS_SHOWING_CSV_FORM_FOR_GROUPS, SET_IS_SHOWING_FILTER_FORM_FOR_GROUPS, SET_IS_SHOWING_MODIFY_FORM_FOR_GROUPS, IGroup, AppendGroupsData, APPEND_GROUPS_DATA, UpdateGroupsLocationAction, UpdateGroupsLocationRequestAction, UPDATE_GROUPS_LOCATION, UPDATE_GROUPS_LOCATION_REQUEST, BulkUpdateGroupComputedFieldDataAction, BULK_UPDATE_GROUP_COMPUTED_FIELD_DATA, RECOMPUTE_ALL_GROUPS, UpdateGroupComputedFieldDataAction, UPDATE_GROUP_COMPUTED_FIELD_DATA, RecomputeAllGroupsAction, ComputedFieldUpdatePayloadForGroup, BULK_RECALCULATE_COMPUTED_FIELDS_FOR_GROUP, ChangeDeltaForGroupComputedFields, RecalculateComputedFieldsForGroupAction, RECALCULATE_COMPUTED_FIELDS_FOR_GROUP, CLEAR_GROUP_ENTRIES, ISetTotalNumberOfGroupsFromServerAction, SET_TOTAL_NUMBER_OF_GROUPS_FROM_SERVER } from './types';
import moment from 'moment';
import { SearchIndex } from '../../helpers/common-types';
import { CustomFieldDataHolder } from '../custom-fields/types';

export function addGroup(payload: IUpdateableGroupData): AddGroupAction {
    const now = moment.utc().format();

    return {
        type: ADD_GROUP,
        payload: {
            ...payload,
            createdTime: now,
            lastUpdatedTime: now,
            lastUpdatedCustomFieldTime: now,
            lastUpdateTimeForFields: {},
            workflows: {},
        },
        currentTime: now,
    }
}

export function updateGroupRequest(payload: IUpdateableGroupData): UpdateGroupRequestAction {
    return {
        type: UPDATE_GROUP_REQUEST,
        payload,
    }
}

export function updateGroup(payload: IUpdateableGroupData): UpdateGroupAction {
    return {
        type: UPDATE_GROUP,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function addMemberToGroup(groupId: string, memberId: string): AddMemberToGroupAction {
    return {
        type: ADD_MEMBER_TO_GROUP,
        groupId,
        memberId,
    }
}

export function removeMemberFromGroup(groupId: string, memberId: string): RemoveMemberFromGroupAction {
    return {
        type: REMOVE_MEMBER_FROM_GROUP,
        groupId,
        memberId,
    }
}

export function bulkAddMembersToGroups(links: Array<GroupMemberLink>): BulkAddMembersToGroupsAction {
    return {
        type: BULK_ADD_MEMBERS_TO_GROUPS,
        links,
    }
}

export function bulkRemoveMembersFromGroups(links: Array<GroupMemberLink>): BulkRemoveMembersFromGroupsAction {
    return {
        type: BULK_REMOVE_MEMBERS_FROM_GROUPS,
        links,
    }
}

export function addWorkflowToGroup(groupId: string, workflowTypeId: string, workflowId: string): AddWorkflowToGroupAction {
    return {
        type: ADD_WORKFLOW_TO_GROUP,
        groupId,
        workflowTypeId,
        workflowId,
    }
}

export function removeWorkflowFromGroup(groupId: string, workflowTypeId: string, workflowId: string): RemoveWorkflowFromGroupAction {
    return {
        type: REMOVE_WORKFLOW_FROM_GROUP,
        groupId,
        workflowTypeId,
        workflowId,
    }
}

export function updateGroupCustomFieldData(workflowId: string, groupId: string, customFieldData: CustomFieldDataHolder): UpdateGroupCustomFieldDataAction {
    return {
        type: UPDATE_GROUP_CUSTOM_FIELD_DATA,
        workflowId,
        groupId,
        customFieldData,
        currentTime: moment.utc().format(),
    }
}

export function updateGroupComputedFieldData(groupId: string, customFieldData: CustomFieldDataHolder): UpdateGroupComputedFieldDataAction {
    return {
        type: UPDATE_GROUP_COMPUTED_FIELD_DATA,
        groupId,
        customFieldData,
        currentTime: moment.utc().format(),
    }
}

export function bulkUpdateGroupComputedFieldData(payload: Array<ComputedFieldUpdatePayloadForGroup>): BulkUpdateGroupComputedFieldDataAction {
    return {
        type: BULK_UPDATE_GROUP_COMPUTED_FIELD_DATA,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function recomputeAllGroups(): RecomputeAllGroupsAction {
    return {
        type: RECOMPUTE_ALL_GROUPS,
    };
}

export function updateGroupsLocationRequest(groupIds: Array<string>, locationId: string): UpdateGroupsLocationRequestAction {
    return {
        type: UPDATE_GROUPS_LOCATION_REQUEST,
        groupIds,
        locationId,
        currentTime: moment.utc().format(),
    }
}

export function updateGroupsLocation(groupIds: Array<string>, locationId: string): UpdateGroupsLocationAction {
    return {
        type: UPDATE_GROUPS_LOCATION,
        groupIds,
        locationId,
        currentTime: moment.utc().format(),
    }
}

export function setMembersForGroupRequest(groupId: string, memberTypes: 'representatives' | 'all_members', memberIds: Array<string>): SetMembersForGroupRequestAction {
    return {
        type: SET_MEMBERS_FOR_GROUP_REQUEST,
        groupId,
        memberTypes,
        memberIds,
    }
}

export function setMembersForGroup(groupId: string, memberTypes: 'representatives' | 'all_members', memberIds: Array<string>): SetMembersForGroupAction {
    return {
        type: SET_MEMBERS_FOR_GROUP,
        groupId,
        memberTypes,
        memberIds,
    }
}

export function deleteGroup(id: string): DeleteGroupAction {
    return {
        type: DELETE_GROUP,
        id,
        currentTime: moment.utc().format(),
    }
}

export function unArchiveGroup(id: string): UnArchiveGroupAction {
    return {
        type: UN_ARCHIVE_GROUP,
        id,
        currentTime: moment.utc().format(),
    }
}

export function searchGroupTable(searchTerm: string): SearchGroupTableAction {
    return {
        type: SEARCH_GROUP_TABLE,
        searchTerm,
    }
}

export function filterGroupTable(projects: Array<string>, types: Array<string>, locations: Array<string>, customFields: { [customFieldId: string]: Array<string> }, createdDateRange: Array<string>, lastUpdatedDateRange: Array<string>, unsynced: boolean, archived: boolean): FilterGroupTableAction {
    return {
        type: FILTER_GROUP_TABLE,
        projects,
        types,
        locations,
        customFields,
        createdDateRange,
        lastUpdatedDateRange,
        unsynced,
        archived,
    }
}

export function setIsFilteringForGroupTable(isFiltering: boolean): SetIsFilteringForGroupTableAction {
    return {
        type: SET_IS_FILTERING_FOR_GROUP_TABLE,
        isFiltering,
    };
}

export function setTotalNumberOfGroups(totalNumberOfGroups: number): ISetTotalNumberOfGroupsFromServerAction {
    return {
        type: SET_TOTAL_NUMBER_OF_GROUPS_FROM_SERVER,
        totalNumberOfGroups,
    }
}

export function goToPageGroupTable(pageNumber: number): GoToPageGroupTableAction {
    return {
        type: GO_TO_PAGE_GROUP_TABLE,
        pageNumber,
    }
}

export function setPageSizeGroupTable(pageSize: number): SetPageSizeGroupTableAction {
    return {
        type: SET_PAGE_SIZE_GROUP_TABLE,
        pageSize,
    }
}

export function sortGroupTable(column: string, order: 'ASC' | 'DESC'): SortGroupTableAction {
    return {
        type: SORT_GROUP_TABLE,
        column,
        order,
    }
}

export function setIsShowingAddFormForGroups(showValue: boolean): SetIsShowingAddFormForGroupsAction {
    return {
        type: SET_IS_SHOWING_ADD_FORM_FOR_GROUPS,
        showValue,
    }
}

export function setIsShowingModifyFormForGroups(showValue: boolean): SetIsShowingModifyFormForGroupsAction {
    return {
        type: SET_IS_SHOWING_MODIFY_FORM_FOR_GROUPS,
        showValue,
    }
}

export function setIsShowingFilterFormForGroups(showValue: boolean): SetIsShowingFilterFormForGroupsAction {
    return {
        type: SET_IS_SHOWING_FILTER_FORM_FOR_GROUPS,
        showValue,
    }
}

export function setIsShowingCSVFormForGroups(showValue: boolean): SetIsShowingCSVFormForGroupsAction {
    return {
        type: SET_IS_SHOWING_CSV_FORM_FOR_GROUPS,
        showValue,
    }
}

export function appendGroups(members: Array<IGroup>): AppendGroupsData {
    return {
        type: APPEND_GROUPS_DATA,
        data: members,
    }
}

export function recalculateComputedFieldsForGroup(
    groupId: string,
    groupChanged: boolean,
    locationChanged: boolean,
    membersChanged: boolean,
    workflowTypesChanged: Array<string>,
): RecalculateComputedFieldsForGroupAction {
    return {
        type: RECALCULATE_COMPUTED_FIELDS_FOR_GROUP,
        groupId,
        groupChanged,
        locationChanged,
        membersChanged,
        workflowTypesChanged,
    }
};

export function bulkRecalculateComputedFieldsForGroup(payload: Array<ChangeDeltaForGroupComputedFields>) {
    return {
        type: BULK_RECALCULATE_COMPUTED_FIELDS_FOR_GROUP,
        payload,
    }
}

export function clearGroupEntries() {
    return {
        type: CLEAR_GROUP_ENTRIES,
    }
}